import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


const Logout = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check if the user is logged in
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/home");
  };

  return (
    <>
      {isLoggedIn && (
        <div className="flex justify-center items-center">
          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="relative bg-lightBlue-500 text-white font-bold px-4 py-2 rounded shadow hover:shadow-md"
          >
            Logout
          </button>
        </div>
      )}
    </>
  );
};

export default Logout;
